
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("3XGQA"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("3XGQA", function(module, exports) {

let $2e281e5799494aec$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2e281e5799494aec$var$load("h3ABO"),
    $2e281e5799494aec$var$load("l0dTs"),
    $2e281e5799494aec$var$load("9hYRW"),
    $2e281e5799494aec$var$load("kpm7S"),
    $2e281e5799494aec$var$load("gwky3"),
    $2e281e5799494aec$var$load("cWN1a"),
    $2e281e5799494aec$var$load("2YffH"),
    $2e281e5799494aec$var$load("g7ggm"),
    $2e281e5799494aec$var$load("6mHrv"),
    $2e281e5799494aec$var$load("awWN9"),
    $2e281e5799494aec$var$load("cM9WO"),
    $2e281e5799494aec$var$load("3wNgF"),
    $2e281e5799494aec$var$load("8tyVc"),
    $2e281e5799494aec$var$load("hZtKG"),
    $2e281e5799494aec$var$load("dkqvW"),
    $2e281e5799494aec$var$load("lVO3w"),
    $2e281e5799494aec$var$load("hyzoX"),
    $2e281e5799494aec$var$load("cmqxT"),
    $2e281e5799494aec$var$load("h9Ed7"),
    $2e281e5799494aec$var$load("eBRUf"),
    $2e281e5799494aec$var$load("ggdmt"),
    $2e281e5799494aec$var$load("kbRvk"),
    $2e281e5799494aec$var$load("7gHIc"),
    $2e281e5799494aec$var$load("3sb7M"),
    $2e281e5799494aec$var$load("k3jER"),
    $2e281e5799494aec$var$load("9wzNh"),
    $2e281e5799494aec$var$load("8YSo7"),
    $2e281e5799494aec$var$load("ef2hX"),
    $2e281e5799494aec$var$load("aGzPe"),
    $2e281e5799494aec$var$load("9ldRJ"),
    $2e281e5799494aec$var$load("50ame"),
    $2e281e5799494aec$var$load("7do1E"),
    $2e281e5799494aec$var$load("77dkW"),
    $2e281e5799494aec$var$load("1MlIV"),
    $2e281e5799494aec$var$load("9ijrN"),
    $2e281e5799494aec$var$load("6iz6l"),
    $2e281e5799494aec$var$load("4SCW2"),
    $2e281e5799494aec$var$load("jYV57"),
    $2e281e5799494aec$var$load("76qVV"),
    $2e281e5799494aec$var$load("hv4mn"),
    $2e281e5799494aec$var$load("Wowvf"),
    $2e281e5799494aec$var$load("dYtBN"),
    $2e281e5799494aec$var$load("6wr18"),
    $2e281e5799494aec$var$load("kjZZD"),
    $2e281e5799494aec$var$load("55Z9F"),
    $2e281e5799494aec$var$load("4vp3Q"),
    $2e281e5799494aec$var$load("4m4Yp"),
    $2e281e5799494aec$var$load("37ldp"),
    $2e281e5799494aec$var$load("ffEVr"),
    $2e281e5799494aec$var$load("9AXkC"),
    $2e281e5799494aec$var$load("28arV"),
    $2e281e5799494aec$var$load("hhss7"),
    $2e281e5799494aec$var$load("fiBiE"),
    $2e281e5799494aec$var$load("lBssV"),
    $2e281e5799494aec$var$load("dP7ao"),
    $2e281e5799494aec$var$load("hogcU"),
    $2e281e5799494aec$var$load("8QOYK"),
    $2e281e5799494aec$var$load("f1meW"),
    $2e281e5799494aec$var$load("7EorR"),
    $2e281e5799494aec$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.2bcf8055.js.map
